import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=de920580&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=de920580&prod&scoped=true&lang=css&external"
import style1 from "@/assets/styles/webchat-style.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./Dashboard.vue?vue&type=style&index=2&id=de920580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de920580",
  null
  
)

export default component.exports